import {Component, h} from "preact";
import {OptionsSelection} from "./Options/OptionsSelection";


/**
 * @typedef {{
 *      onProceed: function(),
 *      optionsCategories: Membership.OptionsCategory[],
 *      selected: Object<number, Object<number, boolean>>,
 *      onSelectOption: function(number, Object<number, boolean>),
 *      selectedRuntime: null|Membership.Runtime,
 * }} OptionsStepContent.Props
 *
 * @typedef {{
 * }} OptionsStepContent.State
 */
export class OptionsStepContent extends Component
{
	/**
	 * @param {OptionsStepContent.Props} props
	 * @param {OptionsStepContent.State} state
	 * @returns {null|JSX.Element}
	 */
	render (props, state)
	{
		if (props.optionsCategories.length === 0)
		{
			return null;
		}

		const headline = props.selectedRuntime !== null
			? `Optionen für „${props.selectedRuntime.title}“`
			: "Optionen";

		return (
			<div class="_membership-options-categories">
				<div className="_membership-headline">{headline}</div>
				{props.optionsCategories.map(category => (
					<OptionsSelection
						category={category}
						selectedItems={props.selected[category.id] || {}}
						onSelectOption={props.onSelectOption}
					/>
				))}
				<div class="_membership-proceed">
					<button type="button" class="_membership-proceed-button" onClick={props.onProceed}>Weiter</button>
				</div>
			</div>
		);
	}
}
